const initialState = {
  dark: false,
};

// No live action mutates this slice; layout.js still reads state.rendering.dark.
const rendering = (state = initialState) => state;

export default rendering;
